import React from 'react'

import {
  SampleDesignCard,
  SampleTextCard
} from '@/molecules/BlogCard/SampleCard'

/* styling */
import masonryStyles from '../../../styles/designMasonry.module.css'

interface Props {
  samples: SamplePost[]
  type: 'design' | 'text'
}

function SamplesListing({ samples, type }: Props) {
  if (type === 'text') {
    return (
      <section className="grid gap-4 md:gap-8 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {samples.map(post => {
          return (
            <article key={post.id}>
              <SampleTextCard
                title={post.title}
                slug={`/samples/${post.slug}/`}
                categories={post.categories.edges}
                wordCount={post.sampleTextPostMetadata?.wordCount ?? undefined}
              />
            </article>
          )
        })}
      </section>
    )
  }

  if (type === 'design') {
    return (
      <section className={masonryStyles.designMasonryGrid}>
        {samples.map(post => {
          if (!post.sampleDesignPostMetadata) return
          return (
            <article key={post.id}>
              <SampleDesignCard
                title={post.title}
                slug={`/samples/${post.slug}/`}
                categories={post.categories.edges}
                imageLink={post.sampleDesignPostMetadata.image.sourceUrl}
                imageWidth={
                  post.sampleDesignPostMetadata.image.mediaDetails.width
                }
                imageHeight={
                  post.sampleDesignPostMetadata.image.mediaDetails.height
                }
              />
            </article>
          )
        })}
      </section>
    )
  }

  return null
}

export default SamplesListing
